<template>
  <div class="industryMonitor">
    <el-container style="height: 100%;min-height:100vh;" direction="vertical">
      <el-header >
        <span style="font-size: 24px;">工业自动化&智能化生产监测解决方案</span>
      </el-header>
      <el-main>
        <el-row>
          <span style="font-size: 20px;">1.应用场景</span>
          <p>工业自动化&智能化生产监测主要针对各个传统生产企业进行自动化、智能化改造以支持工业4.0标准。如下图所示</p>
        </el-row>
        <el-row>
          <img width="600px" height="300px" src="@/assets/image/industry_monitor3.png">
        </el-row>
        <el-row>
          <img width="600px" height="300px" src="@/assets/image/industry_monitor2.png">
        </el-row>
        <el-row>
          <span style="font-size: 20px;">2.业务功能</span>
          <center>
            <el-table  :data="envData" ref="multipleTable" border stripe="true">
              <el-table-column type="index" label="序号" width="100"></el-table-column>
              <el-table-column prop="module" label="业务模块" width="200"></el-table-column>
              <el-table-column prop="desc" label="功能描述"></el-table-column>
            </el-table>
          </center>
        </el-row>
        <el-row>
          <span style="font-size: 20px;">3.解决问题</span>
          <center>
            <el-table  :data="envProblem" ref="multipleTable" border stripe="true">
              <el-table-column type="index" label="序号" width="100"></el-table-column>
              <el-table-column prop="desc" label="问题描述"></el-table-column>
            </el-table>
          </center>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      envData: [{
        id: '1',
        module: '智能制造',
        desc: '数据终端与生产设备相连，自动侦测设备的各类运行状态，获悉该设备正在加工的产品及状态持续时间，还可以列表显示各台设备的数字信息'
      }, {
        id: '2',
        module: '智能监测',
        desc: '实时显示设备状态开、停、加工、待机状态，对设备24小时状态时序显示，设备利用状况一目了然'
      }, {
        id: '3',
        module: '智能计划',
        desc: '提供对园区排污企业名录的实时监测、统计查询'
      }, {
        id: '4',
        module: '供应链管理',
        desc: '提供对园区排污企业建立污染源名录库，对污染源进行分类分级管理'
      }, {
        id: '5',
        module: '销售管理',
        desc: '解决传统运维过程中存在的“管不到、管不全、管不好”的难题'
      }, {
        id: '6',
        module: '视频监控',
        desc: '实现了实时监控、录像回放、图片查询及电视墙等应用'
      }, {
        id: '7',
        module: '协同管理',
        desc: '实现对超标报警、呆滞、离线、异常、故障等数据进行溯源分析'
      }, {
        id: '8',
        module: '预警分析',
        desc: '通过对企业的排污指标数据进行大数据分析预警'
      }, {
        id: '9',
        module: '应急管理',
        desc: '通过组织运维人员、企业负责人和应急专家多方联合，合理建设应急物资装备库来处理突发应急事件'
      }],
      envProblem: [{
        id: '1',
        desc: '通过智能互动与消费者建立亲密关系,提示订单获取能力'
      }, {
        id: '2',
        desc: '通过耗材和服务订阅提高收入'
      }, {
        id: '3',
        desc: '通过优化物联网数据降低成本'
      }, {
        id: '4',
        desc: '通过自动化、人工智能提升安全生产，降低人工成本'
      }]
    }
  }
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.industryMonitor {
  margin: 0px;
  padding: 0px;
}
.el-row {
  margin-top: 10px;
  padding-top: 10px;
}
.el-table {
  margin-left: 50px;
  margin-right: 50px;
  width: 800px;
}
</style>
